import { formatVal } from '../../../helpers/value'
import { PERFORMANCE_SCORE_COLOR_ID } from './constants'

export const handlePortfolio = (data) =>
  data.map((item) => ({
    label: item?.portfolioName,
    value: item?.portfolioId,
  }))

export const handelTotalCompany = (data) =>
  data.reduce(
    (accumulator, currentValue) => accumulator + currentValue.count,
    0,
  )

export const handleDataCreditScore = (data) => {
  const total = handelTotalCompany(data)
  return [...data].map((item) => ({
    name: item?.name,
    value: item?.count,
    color: item?.colorCode || '#BCBCBC',
    percent: Number(formatVal((item.count / total) * 100)),
    total,
  }))
}

export const handleDataPerformanceScore = (data) => {
  const total = handelTotalCompany(data)
  return [...data].map((item, index) => ({
    name: item?.name,
    value: item?.count,
    color: PERFORMANCE_SCORE_COLOR_ID[item.scoreRangeId],
    percent: Number(formatVal((item.count / total) * 100)),
    total,
  }))
}
